import {
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Skeleton,
} from '@mui/material';
import Icon from '@apigrowfinance/pbolt-icon';

import TimelineDots from '@components/accountStatements/TimelineDots';

const TransactionSkeleton = () => {
    return (
        <ListItemButton
            data-testid="transaction-loader"
            sx={{
                width: '100%',
                display: 'block',
                pt: 0,
                pb: 0,
                cursor: 'default',
            }}>
            <ListItem
                sx={{ pl: 0, pt: 0, pb: 0 }}
                secondaryAction={
                    <ListItemText
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                        }}
                        primary={<Skeleton width={80} />}
                        secondary={<Skeleton width={50} />}
                    />
                }>
                <TimelineDots />
                <ListItemAvatar>
                    <Icon data-testid="loading-icon" isLoading>
                        <div />
                    </Icon>
                </ListItemAvatar>
                <ListItemText
                    primary={<Skeleton width={120} />}
                    secondary={<Skeleton width={180} />}
                />
            </ListItem>
        </ListItemButton>
    );
};

export default TransactionSkeleton;
